<template>

    <v-button-toolbar>
        <v-dropdown icon="fas fa-comment" :size="size" menu-position="tl" :items="toneItems" :selected="params.tone" @change="params.tone = $event.key" />
        <v-dropdown icon="far fa-globe" :size="size" menu-position="tl" :items="languageItems" :selected="params.lang" @change="params.lang = $event.key" />
        <v-button :size="size" icon="fas fa-sparkles" theme="white-primary" :loading="loading" @click.native="generateReply">{{ $t('labels.generate') }}</v-button>
    </v-button-toolbar>

</template>

<script>

import { languages } from '@/config';
import ReviewApi from '@api/ReviewApi';

export default {

    props: {
        reviewId: {
            type: Number,
            required: true,
        },
        size: {
            type: String,
            default: 'xs',
        },
    },

    data() {
        return {
            loading: false,
            params: {
                tone: 'friendly',
                lang: 'auto',
                length: '',
            },
            toneItems: [
                {
                    key: 'friendly',
                    value: this.$t('tones.friendly'),
                    icon: 'fas fa-face-smile',
                },
                {
                    key: 'formal',
                    value: this.$t('tones.formal'),
                    icon: 'fas fa-face-meh',
                },
                {
                    key: 'empathetic',
                    value: this.$t('tones.empathetic'),
                    icon: 'fas fa-face-sad-tear',
                },
                {
                    key: 'grateful',
                    value: this.$t('tones.grateful'),
                    icon: 'fas fa-face-kiss-beam',
                },
                {
                    key: 'enthusiastic',
                    value: this.$t('tones.enthusiastic'),
                    icon: 'fas fa-face-grin-stars',
                },
                {
                    key: 'casual',
                    value: this.$t('tones.casual'),
                    icon: 'fas fa-face-laugh',
                },
                {
                    key: 'apologetic',
                    value: this.$t('tones.apologetic'),
                    icon: 'fas fa-face-sad-cry',
                },
                {
                    key: 'informative',
                    value: this.$t('tones.informative'),
                    icon: 'fas fa-face-thinking',
                },
                {
                    key: 'humorous',
                    value: this.$t('tones.humorous'),
                    icon: 'fas fa-face-grin-wink',
                },
            ],
        }
    },

    computed: {

        languageItems() {
            let langs = Object.entries(languages).map(([key, value]) => ({ key, value }));
            langs.push({
                el: 'divider',
            });
            langs.push({
                key: 'auto',
                value: this.$t('labels.auto_detect'),
                icon: 'far fa-globe',
            });
            return langs;
        },

    },

    methods: {

        generateReply() {
            this.loading = true;
            ReviewApi.generateReply(this.reviewId, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('change', response.data.data);
                })
                .catch((error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
